import * as React from 'react';

export interface LoadingProps {
  message?: string;
}
export const Loading: React.SFC<LoadingProps> = props => {
  return (
    <span>
      <i className="fa fa-spinner fa-spin fa-fw" />
      <span>{props.message ? props.message : 'Loading...'}</span>
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/common/components/Loading.tsx